<rask-fieldset-toggle
    label="Transporttilldelad"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-checkbox-list
        label="Transporttilldelad"
        [formControlName]="name"
        [items]="options"
        [selected]="control.value">
    </rask-checkbox-list>
</rask-fieldset-toggle>